import(/* webpackMode: "eager" */ "/Users/kohjx/actions-runner/_work/IDEight-v3/IDEight-v3/apps/web/app/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/kohjx/actions-runner/_work/IDEight-v3/IDEight-v3/node_modules/next/dist/client/app-dir/link.js");
